module.exports = " <div :id=idName @click=generate> <slot> Download {{name}} </slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-json-excel/JsonExcel.vue
// module id = 185
// module chunks = 0